/**
 * 定义mutations 变量名
 */

export const SETACTIVEINDEX = 'set_activeindex'; // 修改当前选中的下标
export const SETENDCENTER = 'set_endcenter'; // 修改abs
export const CHANGESIZE = 'change_size'; // 修改abs